import SessionStorageService from "../services/SessionStorageService";
import { FormSectionElements, FormSections, FormSubSections, FunctionDetail, Organization, ProgramContainer } from "../entities/formTemplateDataType";
import Utils from "./Utils";
import DataUtils from "./DataUtils";
import axios from "axios";
import URLUtils from "./URLUtils";
import { FormEntity } from "../entities/FormEntity";
import { TemplateStatus, TOKEN_TYPE } from "../entities/Constants";
import { isRuntime } from "../config";

export default class CMAUtils {
    static generateCMASection = (programContainer: ProgramContainer) => {

        const reviewPageIndex = 4;
        const dashboardIndex = 3;

        const listSection = programContainer.ListOfFormSections.filter(p => !p.Dynamic);
        listSection[dashboardIndex].ENUDescription = programContainer.organizationName;
        listSection[reviewPageIndex].ENUDescription = programContainer.organizationName;
        listSection[dashboardIndex].FRADescription = programContainer.organizationName;
        listSection[reviewPageIndex].FRADescription = programContainer.organizationName;

        let functions = programContainer.CMATemplateList.filter(t => t.Name == programContainer.Template)[0].Functions;
     
        functions = functions?.map(f => {
            const filteredFunc = new FunctionDetail();
            filteredFunc.FunctionName = f.FunctionName;
            filteredFunc.CategoryDetailList = f.CategoryDetailList.filter(c => Utils.isNotNullOrEmpty(c.SubcategoryNameList));
            filteredFunc.CategoryNameList = filteredFunc.CategoryDetailList.map(c => c.CategoryName);
            return filteredFunc;
        });

        functions = functions?.filter(f => f.CategoryDetailList.length != 0);

        programContainer.ListOfFormSections = [];
        programContainer.ListOfFormSections.push(...listSection);
 
        functions?.forEach((f, findex) => {
            f.CategoryDetailList.forEach((c, index) => {
                let newSection = new FormSections();
                newSection.ENUTitle = "Category " + String(index + 1) + ": " + c.CategoryName;
                newSection.ENUDescription = `Function ${findex + 1}: ${f.FunctionName}`;
                newSection.FRATitle = "Catégorie " + String(index + 1) + " : " + (programContainer.CategoryNameList.find(cat => cat.code == c.CategoryName).FRA);
                newSection.FRADescription = `Fonction ${findex + 1} : ${programContainer.FunctionNameList.find(func => func.code == f.FunctionName).FRA}`;
                let subsec = new FormSubSections();
                subsec.ListOfFormSectionElements = [];
                subsec.Sequence = 1;
                subsec.Visible = true;
                subsec.parent = newSection;
                c.SubcategoryNameList.forEach((subName) => {
                    const subcatObj = programContainer.SubCategoryNameList.filter((s) => s.code == subName)[0];
                    let ele = new FormSectionElements();
                    ele.Datatype = "CMAQuestion";
                    ele.LoadBindName = subName;
                    ele.Id = f.FunctionName + index + subName;
                    ele.Visible = true;
                    ele.Editable = 'Y';
                    ele.ENUTitle = subcatObj.description;
                    ele.FRATitle = subcatObj.FRADescription;
                    ele.hintExpansionTitle = "Implementation guidelines";
                    ele.hintExpansionTitleFRA = "Directives pour la mise en œuvre";
                    ele.callOutBoxType = "richText";
                    ele.callOutBoxBody = subcatObj.callOutBoxBody;
                    ele.callOutBoxBodyFRA = subcatObj.callOutBoxBodyFRA;
                    ele.parent = subsec
                    subsec.ListOfFormSectionElements.push(ele);
                });
                newSection.ListOfFormSubSections = [subsec];
                newSection.parent = programContainer;
                newSection.Dynamic = true;
                newSection.Sequence = listSection.length + 1;
                listSection.push(newSection);
            });
        });
    
        programContainer.ListOfFormSections = listSection;
       
        return programContainer;
    }

    static saveCMA = async (programContainer: ProgramContainer, status = null) => {
        if (isRuntime() == 'false') return false;
        let success = false;

        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        const headers = { 'Authorization': `Bearer ${token}`}

        const api = "data/case";
        let entity = programContainer.Entity;
        
        if(!entity) return false;

        const formValue = DataUtils.collectFormValue(programContainer);
        console.log("Form value", formValue);
        // const valueObject = CircularJSON.parse(formValue);
        delete formValue.createdById;
        delete formValue.createdDate;
        delete formValue.id;
        delete formValue["Questionnaire__List"];
        delete formValue["Assessment__List"];
        if (formValue) {
            entity = { ...entity ?? {}, formValue } as FormEntity;
        }
        console.log("status", status);
        if (status === "Assigned" || !status) {
            entity.status = "InProgress";
        } else {
            entity.status = status;
        }

     

        await axios.post(URLUtils.concatUrls(api), entity, {
            withCredentials: true,
            headers: headers
        }).then((response) => {
            if (response.data) {
                console.log(response.data);
                let entity = response.data;
                programContainer.Entity = entity;
                DataUtils.assignFormValue(programContainer);
            } else {
                console.error("Response does not contain 'formValue'.", response.data);
            }
            success = true;
        }).catch((error) => {
            if (error.response) {
                console.error("Server Error:", error.response.status, error.response.data);
            } else if (error.request) {
                console.error("No response received from server:", error.request);
            } else {
                console.error("Error setting up request:", error.message);
            }
        });
        return success;
    }

    static getOrganizationById = async (id: number) => {
        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        const headers = {
            'Authorization': `Bearer ${token}`
        }

        let api = URLUtils.concatUrls("data/org/" + id.toString());

        const response = await axios.get((api), {
            withCredentials: true,
            headers: headers
        })
           
        const entity = response.data;
        return entity;
    }

    static retrieveFormData = async (programContainer: ProgramContainer, status?: string) => {
        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        const headers = {
            'Authorization': `Bearer ${token}`
        }

        let api = URLUtils.concatUrls(`data/case/formdata/${programContainer.orgId}/${programContainer.formDataId}`);

        if (!programContainer.formDataId) {
            let api = URLUtils.concatUrls(`data/case/${programContainer.Template}/${programContainer.orgId}`);
            if (status) {
                api += "/status/" + status.replace(/\s+/g, '');
            }
        }
        
        const response = await axios.get((api), {
            withCredentials: true,
            headers: headers
        });

        const entity = response.data;
        programContainer.Entity = entity;
        DataUtils.assignFormValue(programContainer);
    }

    static getApproverName = (org: Organization, email: string) => {
        if (!email) return null;
        if (org?.CSLead?.email === email) {
            return { firstName: org.CSLead.firstName, lastName: org.CSLead.lastName, email: email }
        }

        if (org?.CSEngagementLead?.email === email) {
            return { firstName: org.CSEngagementLead.firstName, lastName: org.CSEngagementLead.lastName, email: email };
        }
        return {email};
    }

    static getAssessmentAndApprover = async (programContainer: ProgramContainer) => {
        const entity = programContainer.Entity;
        if (!entity?.template || !entity?.orgId || !entity?.status
            || [TemplateStatus.ASSIGNED, TemplateStatus.IN_PROGRESS, TemplateStatus.REVISION].includes(entity.status)) 
        return null;

        const access_token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        const headers = { 'Authorization': `Bearer ${access_token}`}

        const url = URLUtils.concatUrls(`data/case/formdata/${programContainer.orgId}/${programContainer.formDataId}`);
        //const url = URLUtils.concatUrls(`data/case/assessment/${entity.template}/${entity.orgId}/${entity.status.replace(/\s+/g, '')}`);
        try {
            const response = await axios.get((url), {
                withCredentials: true,
                headers: headers
            });
            if (response.data) {
                return {
                    assessment: response.data.assessmentName,
                    organizationName: response.data.organizationName,
                    approvalDate: response.data.approvalDate,
                    approver: response.data.approver,
                    assessor: response.data.assessor,
                }
            } else {
                console.info("No data found for the given template and organization.");
                return null;
            }
        } catch (error) {
            console.error("Error fetching assessment and approver:", error);
            return null;
        }
    };
}
